const INITIAL_STATE = {
  settings: {
    guest_feature_enabled: false,
    friend_invite_limit: 0,
    limit_by_audience_enabled: false,
  },
  settingsLoading: false,
  settingsSaving: false,
  list: {
    items: [],
    total: 0,
    page: 1,
    limit: 20,
  },
  listLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GUEST_CONTROL_SETTINGS_LOAD':
      return { ...state, settingsLoading: action.payload };
    case 'GUEST_CONTROL_SETTINGS_FETCHED':
      return {
        ...state,
        settings: {
          guest_feature_enabled: !!action.payload.guest_feature_enabled,
          friend_invite_limit: action.payload.friend_invite_limit || 0,
          limit_by_audience_enabled: !!action.payload.limit_by_audience_enabled,
        },
        settingsLoading: false,
      };
    case 'GUEST_CONTROL_SETTINGS_SAVE':
      return { ...state, settingsSaving: action.payload };
    case 'GUEST_CONTROL_LIST_LOAD':
      return { ...state, listLoading: action.payload };
    case 'GUEST_CONTROL_LIST_FETCHED':
      return {
        ...state,
        list: {
          items: action.payload.items || [],
          total: action.payload.total || 0,
          page: action.payload.page || 1,
          limit: action.payload.limit || 20,
        },
        listLoading: false,
      };
    default:
      return state;
  }
};
